module.exports = __webpack_public_path__ + "static/img/permit.64b21d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/permit.png
// module id = WEqX
// module chunks = 0